export default {
  loading: false,
  downloadLink: null,
  form: {
    file: null,
    logisticProviderId: null,
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/occurrences-validation/store/states.js